// extracted by mini-css-extract-plugin
export default {"tableRow":"tableRow__-bsIH","modal":"modal__03idK"};